import * as React from "react";
function SvgMicOn(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.044 9v-.002V9l-.002.035a15.13 15.13 0 01-.006.114v.014a17.939 17.939 0 00-.031 1.526c.02.922.122 2.12.468 3.32.345 1.197.95 2.454 2.015 3.415.89.804 2.05 1.35 3.512 1.52V22h2v-3.054c1.452-.162 2.606-.682 3.498-1.457 1.07-.93 1.68-2.152 2.027-3.331.59-2.002.481-4.14.442-4.907-.006-.118-.01-.203-.01-.25l-2-.001c0 .109.006.258.014.44.038.882.11 2.541-.364 4.152-.279.946-.727 1.786-1.42 2.387C14.51 16.566 13.518 17 12 17c-1.505 0-2.493-.45-3.172-1.062-.699-.63-1.152-1.508-1.433-2.484-.487-1.689-.401-3.396-.363-4.146.006-.136.012-.24.012-.308h-2zM14 12V6a2 2 0 00-4 0v6a2 2 0 104 0zM12 2a4 4 0 00-4 4v6a4 4 0 008 0V6a4 4 0 00-4-4z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgMicOn);
export default ForwardRef;
